export default "__VITE_ASSET__3c251f28__"